'use client'

import { LoginForm } from '@/components/auth/login-form'
import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
} from '@/components/extension/responsive-modal'
import { Button } from '@/components/ui/button'
import { useIsLoggedIn } from '@/hooks/react-query/user/use-user'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { showPopup } from '@/providers/popup-provider'
import Image from 'next/image'

interface CoolClubInfoModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const CoolClubInfoModal = ({
  open,
  onOpenChange,
}: CoolClubInfoModalProps) => {
  const isLoggedIn = useIsLoggedIn()

  const handleJoinCoolClub = () => {
    showPopup(<LoginForm />)
    onOpenChange(false)
  }

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange}>
      <ResponsiveModalContent
        className='max-h-[80vh] gap-0 border-none px-5 py-8 max-md:bottom-0 max-md:top-auto max-md:translate-y-0 max-md:overflow-y-auto lg:max-w-[800px] lg:p-8'
        side='center'
      >
        <ResponsiveModalTitle className='text-2xl'>
          Happy Friday X2 CoolCash
        </ResponsiveModalTitle>
        <ResponsiveModalDescription />
        <div className=''>
          <p className='text-sm'>
            Thứ 6 hàng tuần, Hội viên CoolClub được nhận đôi hoàn tiền CoolCash
            khi đăng nhập và mua hàng trên website Coolmate.*
          </p>
          <p className='mb-6 text-sm'>
            <span className='font-medium'>Ví dụ:</span> Hội viên CoolClub đăng
            nhập và mua 1 đơn hàng trị giá 500.000đ trên website Coolmate được
            hoàn tiền như sau:
          </p>
          <picture>
            <source
              srcSet={ImageHelper.getImageUrlCdn(
                '/image/April2024/mceclip2_42.png'
              )}
              media='(max-width: 991px)'
            />
            <Image
              src={ImageHelper.getImageUrlCdn(
                '/image/April2024/mceclip0_46.png'
              )}
              alt='Happy Friday X2 CoolCash'
              width={500}
              height={500}
              className='w-full'
            />
          </picture>

          <p className='mb-1 mt-2 text-sm text-neutral-500'>
            *Chương trình áp dụng thứ Sáu hàng tuần, bắt đầu từ 19/04/2024.
          </p>

          {!isLoggedIn && (
            <div className='mb-4 rounded-lg bg-neutral-100 p-4'>
              <p className='mb-1 text-center text-sm font-medium'>
                Để không bỏ lỡ hoàn tiền CoolCash cho bất kỳ đơn hàng nào:
              </p>
              <div className='flex justify-center'>
                <Button onClick={handleJoinCoolClub} variant={'black'}>
                  THAM GIA COOLCLUB
                </Button>
              </div>
            </div>
          )}
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
